import { find, first } from 'lodash';

function getStatusTemplate(option) {
  return `<span class="tag_grid_item" style="pointer-events:none;background: ${option.color}"></span><span class="status_list_item_focused">${option.locale ? __(option.locale) : option.name}</span>`;
}

function getPriorityTemplate(option) {
  return `<span class="webix_icon icon_list_item" style="pointer-events:none;background-image: url(${option.icon})"></span><span class="priority_list_item">${option.locale ? __(option.locale) : option.name}</span>`;
}

export function getTemplate(column, instance, task) {

  if (task.type === instance.config.types.project || task.type === instance.config.types.button) {
    return '';
  }

  let finishOption = {};

  if (column.name === 'jira_key') {
    return (task.jira_key || '');
  }

  finishOption = find(column.options, optionsItem => (+optionsItem.id === +task[column.name])) || find(column.options, optionsItem => optionsItem.is_default) || first(column.options);

  if (finishOption.color && column.name === 'status') {
    return getStatusTemplate(finishOption);
  } if (finishOption.icon && column.name === 'priority') {
    return getPriorityTemplate(finishOption);
  }

  return finishOption.locale ? __(finishOption.locale) : finishOption.name;
}
